module.exports = __webpack_public_path__ + "02_glasses_brown.0f69d069.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/02_glasses_brown.png
// module id = 3jOJ
// module chunks = 0